var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper_box_list"},[_c('swiper',{staticClass:"brand_box",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.Logos),function(item,index){return _c('swiper-slide',{key:index,staticClass:"brand_list"},[_c('img',{staticClass:"brand_img",attrs:{"src":item.url}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bc37652","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/swiper/manufacturer.vue
// module id = null
// module chunks = 